import type { Translations } from './types';

export const fr: Translations = {
  common: {
    back: 'Retour',
    cancel: 'Annuler',
    save: 'Enregistrer',
    delete: 'Supprimer',
    retry: 'Réessayer',
    loading: 'Chargement...',
    close: 'Fermer',
    yes: 'Oui',
    no: 'Non',
    ok: 'OK',
    or: 'ou',
    play: 'Lecture',
    stop: 'Arrêt',
    goBack: 'Retour',
    returnHome: "Retour à l'accueil",
    dismiss: 'Fermer',
    unoccupied: 'Inoccupé',
    resident: 'résident',
  },
  login: {
    appName: 'CARO Care',
    subtitle: 'Connectez-vous pour continuer',
    emailLabel: 'E-mail',
    passwordLabel: 'Mot de passe',
    signingIn: 'Connexion...',
    signIn: 'Se connecter',
    qrButton: 'Activer avec un QR Code',
    helpText: "Besoin d'aide ? Contactez",
    adminSetup: "Configuration de l'appareil admin",
    activeSessionTitle: 'Un autre appareil est connecté',
    activeSessionMessage: 'Ce compte est actif sur un autre appareil. Continuer déconnectera tous les autres appareils.',
    logoutOthers: 'Continuer & Déconnecter les autres',
    cancelLogin: 'Annuler',
  },
  home: {
    greetingMorning: 'Bonjour',
    greetingAfternoon: 'Bon après-midi',
    greetingEvening: 'Bonsoir',
    greetingNight: 'Bonne nuit',
    phoneReady: 'Prêt',
    phoneConnecting: '...',
    phoneError: 'Err',
    geofenceOutside: 'En dehors de la zone !',
    geofenceInside: 'Dans la zone',
    geofenceIndicatorOutside: 'Dehors',
    geofenceIndicatorSafe: 'Sûr',
    editLayoutEdit: "Modifier la disposition de l'écran d'accueil",
    editLayoutDone: 'Terminer la modification',
    openDoor: 'Ouvrir la porte',
    openDoorSuccess: "Ouverture de la porte",
    openDoorError: "Impossible d'ouvrir la porte",
    apps: 'Applis',
    widgetButtons: 'Boutons',
  },
  emergency: {
    confirmationTitle: "Êtes-vous sûr d'avoir besoin d'aide d'urgence ?",
    buttonYes: 'OUI',
    buttonNo: 'NON',
    buttonNoCancel: 'Non, annuler',
    buttonCancel: 'ANNULER',
    countdownMessage: "Appel d'urgence dans {seconds} secondes...",
    calling: "Appel des services d'urgence...",
    connected: 'Connecté',
    resetAlarm: "Réinitialiser l'alarme",
    cancelled: 'Urgence annulée',
    errorApiFailed: "Impossible de joindre les services d'urgence via l'application.",
    errorSipUnavailable: "Le service téléphonique n'est pas disponible. Pour les urgences, composez directement le 112.",
    call112: 'Appelez le 112',
    tryAgain: 'Réessayer',
    callHelp: "Appeler à l'aide",
    fiveSecondsRemaining: '5 secondes restantes',
    dispatchConnecting: "Alerte de l'équipe soignante…",
    dispatchRetry: 'Nouvel essai… (tentative {n})',
    dispatchFailed: 'Connexion impossible. Nous continuons d\'essayer…',
    dispatchFailedVoice: "Nous ne joignons pas encore l'équipe soignante. Nous continuons d'essayer. Restez calme.",
    tryingToCall: "Appel des services d'urgence…",
    callingWith: "En communication avec les services d'urgence",
    onRoute: 'Les secours sont en route',
    alarmSent: "Alarme envoyée, les secours sont prévenus…",
    alarmActive: 'Les secours sont organisés. Restez calme.',
  },
  settings: {
    title: 'Paramètres',
    homeScreen: "Page d'accueil",
    customizeButtons: 'Personnaliser les boutons',
    connectionStatus: 'État de la connexion',
    allConnected: 'Tout connecté',
    display: 'Affichage & Thème',
    language: 'Langue',
    about: 'À propos de CARO Care',
    testMode: 'Mode test',
    logout: 'Se déconnecter',
    replayOnboarding: "Revoir la visite d'accueil",
    permissions: "Autorisations de l'app",
    permissionsValue: 'Microphone, caméra, localisation',
    permissionsTitle: "Autorisations de l'app",
    permissionsIntro: "Ces autorisations permettent à l'appareil d'utiliser les appels, la vidéo et les notifications.",
    permissionsAllowAll: 'Autoriser tout',
    permissionsRecheck: 'Revérifier',
    permissionsAllGranted: 'Toutes les autorisations sont accordées',
    permGranted: 'Accordée',
    permDenied: 'Refusée',
    permPrompt: 'Pas encore autorisée',
    permDeniedHelp: "Refusée. Activez-la dans les paramètres système de l'appareil.",
    permMic: 'Microphone',
    permMicDesc: 'Nécessaire pour les appels',
    permCamera: 'Caméra',
    permCameraDesc: "Nécessaire pour les appels vidéo et la caméra de porte",
    permLocation: 'Localisation',
    permLocationDesc: 'Nécessaire pour la sécurité et le geofencing',
    permNotifications: 'Notifications',
    permNotificationsDesc: 'Nécessaire pour afficher les appels entrants',
  },
  buttonLabels: {
    dialer: 'Appeler',
    contacts: 'Contacts',
    photos: 'Photos',
    info: 'Infos',
    games: 'Jeux',
    voicemail: 'Messagerie',
    callHistory: 'Appels',
    settings: 'Paramètres',
    openDoor: 'Ouvrir la porte',
    agenda: 'Agenda',
    weather: 'Météo',
    news: 'Actualités',
    energy: "Énergie",
  },
  onboarding: {
    splashTagline: 'Les soins au bout des doigts',
    welcomeTitle: 'Bienvenue sur CARO Care',
    welcomeSubtitle: 'Votre compagnon de soins personnel, conçu pour vous garder connecté et en sécurité.',
    connectedTitle: 'Restez connecté',
    connectedSubtitle: 'Appelez, voyez qui est à la porte et restez en contact avec votre famille et vos soignants.',
    homeScreenTitle: "Votre écran d'accueil",
    homeScreenSubtitle: 'Météo, actualités, votre agenda et plus encore — tout personnalisable selon vos préférences.',
    getStartedTitle: 'Prêt à commencer',
    getStartedSubtitle: 'Configurons votre appareil. Cela ne prend qu\'un instant.',
    next: 'Suivant',
    skip: 'Passer',
    getStartedButton: 'Commencer',
  },
  contacts: {
    title: 'Contacts',
    emptyTitle: 'Pas encore de contacts.',
    emptyDescription: 'Votre famille et vos soignants peuvent ajouter des contacts pour vous via le portail.',
    callContact: 'Appeler',
    loadError: 'Impossible de charger les contacts. Veuillez réessayer.',
  },
  callHistory: {
    title: "Historique d'appels",
    filterAll: 'Tous',
    filterMissed: 'Manqués',
    filterAnswered: 'Répondus',
    filterVoicemail: 'Messagerie',
    loadError: "Impossible de charger l'historique des appels",
    networkError: 'Erreur réseau',
    noCalls: "Pas encore d'appels",
    today: "Aujourd'hui",
    yesterday: 'Hier',
    statusAnswered: 'Répondu',
    statusMissed: 'Manqué',
    statusVoicemail: 'Messagerie vocale',
    statusRinging: 'Sonne',
    statusRejected: 'Refusé',
    statusFailed: 'Échec',
  },
  voicemail: {
    title: 'Messagerie vocale',
    loadingVoicemails: 'Chargement des messages vocaux...',
    loadError: 'Impossible de charger les messages vocaux',
    emptyTitle: 'Aucun message vocal',
    emptyDescription: "Lorsque quelqu'un vous laisse un message vocal, il apparaîtra ici.",
    statusKept: 'CONSERVÉ',
    statusAutoDelete: 'Suppression auto 14j',
    keep: 'Conserver',
    deleteVoicemail: 'Supprimer',
    confirmDelete: 'Supprimer ce message vocal ?',
    playError: 'Impossible de lire le message vocal',
    deleteError: 'Impossible de supprimer le message vocal',
    updateError: 'Impossible de mettre à jour le message vocal',
    daysAgo: 'il y a {n} jours',
    today: "Aujourd'hui",
    yesterday: 'Hier',
  },
  inCall: {
    connecting: 'Connexion...',
    dialing: 'Appel...',
    onHold: 'En attente',
    ended: 'Appel terminé',
    mute: 'Muet',
    unmute: 'Réactiver',
    keypad: 'Clavier',
    speaker: 'Haut-parleur',
    earpiece: 'Écouteur',
    hold: 'En attente',
    resume: 'Reprendre',
  },
  incomingCall: {
    emergencyCallback: "Rappel d'urgence",
    incoming: 'Appel entrant',
    autoAnswering: 'Réponse automatique...',
    decline: 'Refuser',
    answer: 'Répondre',
  },
  doorbell: {
    viewing: 'Quelqu\'un est à la porte',
    calling: 'Connexion...',
    active: 'Connecté',
    doorOpened: 'Porte ouverte',
    opening: 'Ouverture de la porte...',
    done: 'Appel terminé',
    noCamera: 'Pas de caméra disponible',
    entrance: 'Entrée',
    openDoor: 'Ouvrir la porte',
    answer: 'Répondre',
    decline: 'Refuser',
    hangup: "Terminer l'appel",
    afwijzen: 'Refuser',
    opnemen: 'Répondre',
    ophangen: 'Raccrocher',
    deurOpenen: 'Ouvrir la porte',
    // See nl.ts for why these four exist and why `doorOpened` is not reused.
    doorReleasing: "La porte s'ouvre",
    doorRetried: 'Nouvelle tentative',
    doorSent: "Commande d'ouverture envoyée",
    doorFailed: "Échec de l'ouverture",
  },
  photos: {
    title: 'Photos',
    tabAll: 'Toutes',
    tabFavorites: 'Favoris',
    tabHidden: 'Masquées',
    emptyFavorites: "Pas encore de photos favorites. Appuyez sur le c\u0153ur d'une photo pour l'ajouter !",
    emptyHidden: 'Pas de photos masquées.',
    emptyAll: 'Pas encore de photos. Votre famille peut envoyer des photos via leur lien.',
    unavailable: 'Photo indisponible',
  },
  agenda: {
    title: 'Agenda',
    today: "Aujourd'hui",
    allDay: 'Toute la journée',
    spots: 'places',
    open: 'Ouvrir',
    addedBy: 'Ajouté par',
    emptyMessage: 'Aucun événement prévu cette semaine',
    cancelSignup: "Annuler l'inscription",
    join: 'Rejoindre',
    previousWeek: 'Semaine précédente',
    nextWeek: 'Semaine suivante',
    tomorrow: 'Demain',
    addEntry: '+ Ajouter',
    privateMarker: 'Privé',
    privateExplain: 'Vous seul voyez ceci',
    newEntryTitle: 'Ajouter quelque chose à votre agenda',
    entryTitleLabel: 'De quoi s’agit-il ?',
    entryWhenLabel: 'Quand ?',
    entryDurationLabel: 'Combien de temps ?',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    signupOpen: 'S’inscrire',
    signupClosed: 'Les inscriptions sont clôturées',
    signupFull: 'Complet',
    signupAlready: 'Vous êtes inscrit',
    moreInfo: "Plus d'infos",
    withdrawClosed: 'Cette activité a commencé ou est terminée. Vous ne pouvez plus vous désinscrire — demandez à un membre du personnel.',
    withdrawFailed: 'La désinscription a échoué',
    noBillingAccount: 'Inscrivez-vous auprès de l’accompagnement',
    waitlisted: 'Vous êtes sur la liste d’attente',
    whoIsComing: 'Qui vient ?',
    attendeeYou: 'Vous-même',
    confirmTitle: 'Petite confirmation',
    confirmTotal: 'Total',
    confirmOnApartmentBill: 'Ceci sera porté au compte de votre appartement.',
    confirmYes: 'Oui, inscrivez-moi',
    confirmNo: 'Non, finalement',
    signupFailed: 'L’inscription n’a pas fonctionné. Réessayez ou demandez à l’accompagnement.',
    priceChanged: 'Le prix a changé entre-temps. Veuillez regarder à nouveau.',
  },
  dialer: {
    title: 'Clavier',
    connectingMessage: 'Connexion au service téléphonique...',
    notConnectedMessage: 'Service téléphonique non connecté',
  },
  info: {
    title: 'Info',
    myProfile: 'Mon Profil',
    name: 'Nom',
    email: 'E-mail',
    location: 'Lieu',
    myBuilding: 'Mon Bâtiment',
    building: 'Bâtiment',
    needHelp: "Besoin d'aide ?",
    helpText: "Appuyez sur le bouton d'urgence rouge sur l'écran d'accueil ou demandez l'aide d'un soignant.",
    about: 'À propos de cette application',
    appVersion: 'Version',
    linkedTo: 'Cette tablette est liée à',
    resident: 'Résident',
    apartment: 'Appartement',
    site: 'Site / bâtiment',
    extension: 'Numéro de poste',
    notLinked: 'non liée',
  },
  connectivity: {
    title: 'État de la connexion',
    allConnected: 'Tous les systèmes connectés',
    limited: 'Connectivité limitée',
    offline: 'Hors ligne',
    checking: 'Vérification...',
    emergencyAvailable: "Appels d'urgence disponibles",
    degradedMessage: 'Certains services peuvent être indisponibles',
    offlineMessage: 'Aucune connexion détectée',
    networkLabel: 'Wi-Fi / Réseau',
    networkDescription: 'Connexion réseau locale',
    internetLabel: 'Internet',
    internetDescription: 'Accès Internet',
    apiLabel: 'Serveur CARO',
    apiDescription: 'Services cloud CARO',
    sipLabel: 'Service téléphonique',
    sipDescription: 'Appels vocaux',
    mqttLabel: 'Surveillance',
    mqttDescription: 'Télémétrie et commandes à distance',
    statusOk: 'OK',
    statusDown: 'Indisponible',
    checkAgain: 'Vérifier à nouveau',
    noNetwork: 'Pas de connexion réseau',
    offlineEmergencyText: 'Pour les urgences, composez directement le 112 avec votre téléphone.',
  },
  homeScreenSettings: {
    title: "Page d'accueil",
    subtitle: "Choisissez les boutons qui apparaissent sur votre page d'accueil",
    buttonCount: '{count} sur {total} boutons visibles',
    resetToDefault: 'Réinitialiser',
  },
  games: {
    title: 'Jeux',
    subtitle: 'Gardez l\'esprit vif et amusez-vous',
    memory: { name: 'Mémoire', desc: 'Trouvez les paires' },
    sudoku: { name: 'Sudoku', desc: 'Puzzle de chiffres' },
    wordSearch: { name: 'Mots cachés', desc: 'Trouvez les mots cachés' },
    trivia: { name: 'Quiz', desc: 'Testez vos connaissances' },
    game2048: { name: '2048', desc: 'Glissez et fusionnez' },
    solitaire: { name: 'Solitaire', desc: 'Jeu de cartes classique' },
    ticTacToe: { name: 'Morpion', desc: 'Stratégie X et O' },
    hangman: { name: 'Pendu', desc: 'Devinez le mot' },
    colorMatch: { name: 'Couleurs', desc: 'Mémorisez le motif' },
    chess: { name: 'Échecs', desc: 'Jeu de stratégie classique' },
    checkers: { name: 'Dames', desc: 'Sautez et capturez' },
    findDifferences: { name: 'Trouvez les différences', desc: 'Repérez les changements' },
    slidingPuzzle: { name: 'Taquin', desc: 'Glissez les tuiles en ordre' },
  },
  gameCommon: {
    playAgain: 'Rejouer',
    changeDifficulty: 'Changer la difficulté',
    backToGames: 'Retour aux Jeux',
    newGame: 'Nouvelle partie',
    tryAgain: 'Réessayer',
    keepPlaying: 'Continuer à jouer',
    congratulations: 'Félicitations !',
    score: 'Score',
    best: 'Meilleur',
    time: 'Temps',
    moves: 'Coups',
    easy: 'Facile',
    medium: 'Moyen',
    hard: 'Difficile',
    gameOver: 'Partie terminée !',
  },
  memoryGame: {
    chooseDifficulty: 'Choisissez la difficulté',
    matchPairsSubtitle: 'Trouvez toutes les paires pour gagner !',
    encourageAmazing: 'Mémoire incroyable ! Vous êtes un naturel !',
    encourageGreat: 'Très bien ! Excellent travail !',
    encourageNice: 'Beau travail ! Continuez à pratiquer !',
    encourageWellDone: 'Bien joué ! Chaque partie vous rend plus vif !',
  },
  sudokuGame: {
    chooseDifficulty: 'Choisissez votre difficulté :',
    blanks: 'cases vides',
    hintsUsed: 'Indices utilisés',
    hintsDisplay: 'Indices',
    solvedPuzzle: 'Vous avez résolu le puzzle !',
  },
  game2048: {
    youReached: 'Vous avez atteint 2048 !',
  },
  triviaGame: {
    chooseCategory: 'Choisissez une catégorie pour commencer votre quiz !',
    questions: 'questions',
    questionProgress: 'Question {current} sur {total}',
    correct: 'Correct ! Bien joué !',
    incorrect: 'Pas tout à fait. La bonne réponse est mise en évidence ci-dessus.',
    nextQuestion: 'Question suivante',
    seeResults: 'Voir les résultats',
    chooseCategoryBtn: 'Choisir une catégorie',
    resultPerfect: 'Score parfait ! Vous êtes un maître du quiz !',
    resultExcellent: 'Excellent travail ! Vous connaissez vraiment bien !',
    resultGreat: 'Très bien ! Vous avez une mémoire formidable !',
    resultGood: 'Bon effort ! Continuez à jouer pour en apprendre plus !',
    resultNiceTry: 'Bel essai ! Chaque partie vous rend plus cultivé !',
    history: 'Histoire',
    nature: 'Nature',
    music: 'Musique',
    geography: 'Géographie',
    science: 'Sciences',
  },
  wordSearchGame: {
    chooseTheme: 'Choisissez un thème pour commencer',
    words: 'mots',
    theme: 'Thème',
    wordsFound: 'trouvés',
    hintSelectStart: "Appuyez sur la première lettre d'un mot",
    hintSelectEnd: 'Appuyez sur la fin du mot',
    allWordsFound: 'Tous les mots trouvés !',
    completionMessage: 'Vous avez complété le puzzle !',
    newPuzzle: 'Nouveau puzzle',
    changeTheme: 'Changer de thème',
    animals: 'Animaux',
    food: 'Nourriture',
    natureTheme: 'Nature',
    home: 'Maison',
    colors: 'Couleurs',
  },
  hangmanGame: {
    guessTheWord: 'Devinez le mot !',
    category: 'Catégorie',
    youWon: 'Vous avez trouvé !',
    youLost: 'Trop de mauvaises lettres !',
    theWordWas: 'Le mot était',
    wrongGuesses: 'Mauvaises lettres',
    animals: 'Animaux',
    food: 'Nourriture',
    countries: 'Pays',
    household: 'Maison',
  },
  colorMatchGame: {
    watchPattern: 'Regardez le motif...',
    yourTurn: 'À vous !',
    round: 'Tour',
    bestStreak: 'Meilleure série',
    wrongPattern: 'Faux ! Partie terminée.',
    newRecord: 'Nouveau record !',
  },
  solitaireGame: {
    undo: 'Annuler',
    draw: 'Piocher',
    autoComplete: 'Compléter automatiquement',
    youWon: 'Vous avez gagné !',
    movesUsed: 'Coups utilisés',
  },
  ticTacToeGame: {
    yourTurn: 'Votre tour (X)',
    aiTurn: "L'ordinateur réfléchit...",
    youWin: 'Vous gagnez !',
    aiWins: "L'ordinateur gagne !",
    draw: 'Match nul !',
    chooseDifficulty: 'Choisissez la difficulté :',
    wins: 'Victoires',
    losses: 'Défaites',
    draws: 'Nuls',
  },
  browser: {
    title: 'Navigateur',
    noUrl: 'Aucune URL fournie',
    emergency: 'Urgence',
  },
  display: {
    title: 'Affichage & Thème',
    brightness: 'Luminosité',
    screen: 'Écran',
    sleepMode: 'Mode veille',
    sleepModeDesc: "Éteindre l'écran. Appuyez n'importe où pour réveiller.",
    tapToWake: 'Appuyez pour réveiller',
    fontSize: 'Taille de police',
    fontNormal: 'Normale',
    fontLarge: 'Grande',
    fontXLarge: 'Très grande',
    fontHuge: 'Énorme',
    fontGiant: 'Géante',
    colorTheme: 'Thème de couleur',
    light: 'Clair',
    dark: 'Sombre',
    highContrast: 'Contraste élevé',
    screensaverMode: 'Écran de veille',
    screensaverPhotos: 'Photos',
    screensaverClockOnly: 'Horloge seule',
    standbyBackground: "Fond de l'écran de veille",
    clockStyle: "Style d'horloge",
    clockDigital: 'Numérique',
    clockAnalog: 'Analogique',
    clockSize: "Taille de l'horloge",
    clockSmall: 'Petite',
    clockMedium: 'Moyenne',
    clockLarge: 'Grande',
    clockXLarge: 'Très grande',
    clockHuge: 'Énorme',
    clockBold: "Chiffres de l'horloge",
    clockBoldOff: 'Fins',
    clockBoldOn: 'Gras',
    clockShowYear: "Année dans la date",
    clockShowYearOff: 'Masquer',
    clockShowYearOn: 'Afficher',
    weatherLocation: 'Lieu météo',
    weatherLocationPlaceholder: 'ex. Deinze, Belgique',
    weatherLocationHint: 'Laisser vide pour utiliser le lieu du bâtiment',
    detectLocation: 'Détecter',
    reduceMotion: 'Réduire les animations',
    reduceMotionHint: "Limite les animations et les transitions dans l'application.",
    reduceMotionAuto: "Auto (suivre l'appareil)",
    reduceMotionOn: 'Activé',
    reduceMotionOff: 'Désactivé',
  },
  today: {
    title: "Aujourd'hui",
    noEvents: "Pas d'événements aujourd'hui",
    now: 'MAINT.',
    allDay: 'Toute la journée',
    inTime: 'dans {time}',
    nextEvent: 'Ensuite : {title} à {time}',
  },
  energy: {
    title: "Énergie",
    loading: "Chargement de la consommation...",
    unavailable: "Votre consommation n'est pas encore disponible ici.",
    noMeter: "Aucun compteur n'est encore lié à votre appartement.",
    thisMonth: "Ce mois-ci",
    lastYearSameMonth: "Même mois l'an dernier",
    sinceJanuary: "Depuis janvier",
    middleApartmentSoFar: "L'appartement médian de l'immeuble : {value} jusqu'à présent.",
    last12: "Les 12 derniers mois",
    showList: "En liste",
    showChart: "En graphique",
    running: "en cours",
    thisYear: "Votre consommation",
    lastYear: "l'an dernier",
    comparison: "En {month}, vous avez consommé {you}. L'appartement médian de l'immeuble a consommé {middle}.",
    comparisonNote: "Votre consommation dépend de la taille et de la situation de votre appartement et de votre présence. Une différence n'est donc pas toujours évitable.",
    lastSettlement: "Dernier relevé de décompte : {value} le {date}.",
    footer: "Ces données vous aident à suivre votre consommation. Ce n'est pas une facture.",
  },
  weather: {
    title: 'Météo',
    feelsLike: 'Ressenti',
    humidity: 'Humidité',
    wind: 'Vent',
    sunrise: 'Lever du soleil',
    sunset: 'Coucher du soleil',
    forecast: 'Prévisions',
    loading: 'Chargement météo...',
    unavailable: 'Météo indisponible',
    high: 'H',
    low: 'B',
  },
  news: {
    title: 'Actualités',
    loading: 'Chargement des actualités...',
    noArticles: 'Aucun article disponible',
    readMore: 'Lire la suite',
    sources: 'Sources',
    minutesAgo: 'il y a {n}min',
    hoursAgo: 'il y a {n}h',
  },
  permissions: {
    title: 'Autorisations requises',
    description: 'CARO Care a besoin des autorisations suivantes pour fonctionner correctement. Veuillez autoriser l’accès pour continuer.',
    microphone: 'Microphone',
    microphoneDesc: 'Nécessaire pour les appels téléphoniques et l’alarme d’urgence',
    camera: 'Caméra',
    cameraDesc: 'Nécessaire pour la caméra de sonnette et le scan de code QR',
    location: 'Localisation',
    locationDesc: 'Nécessaire pour la surveillance de sécurité dans votre bâtiment',
    allowAll: 'Autoriser tout',
    deniedHelp: 'Certaines autorisations ont été refusées. Ouvrez Paramètres > Applications > CARO Care > Autorisations pour les activer.',
    notifications: 'Notifications',
    notificationsDesc: 'Nécessaire pour les alertes d\'appels entrants et les notifications d\'urgence',
    openSettings: 'Ouvrir les paramètres',
  },
  battery: {
    lowTitle: 'Batterie faible',
    lowMessage: 'La batterie est faible. Veuillez brancher le chargeur.',
    highTitle: 'Batterie chargée',
    highMessage: 'La batterie est suffisamment chargée. Vous pouvez débrancher le chargeur pour préserver la batterie.',
    lowSpoken: 'Attention. Votre batterie est faible. Veuillez brancher le chargeur.',
  },
  domotics: {
    title: 'Domotique',
    back: '← Retour',
    backPlain: 'Retour',
    loading: 'Chargement en cours',
    notReady: "La domotique n'est pas encore prête sur cet appareil.",
    notEnabled: "La domotique n'est pas activée pour ce logement.",
    editTitle: 'Modifier',
    editButton: '✏️ Modifier',
    doneButton: '✓ Terminé',
    done: 'Terminé',
    editModeHint: "Touchez une tuile pour la renommer, la déplacer, la mettre sur l'écran d'accueil ou la masquer. Rien ne sera allumé ni éteint.",
    allOff: 'Tout est éteint',
    oneOutputOn: ' sortie est allumée',
    manyOutputsOn: ' sorties sont allumées',
    rooms: 'Pièces',
    all: 'Tout',
    noRoomsYet: 'Pas encore de pièces',
    roomsHint: '{label} — créez-en une en ouvrant une tuile et en choisissant « Déplacer vers une pièce ».',
    nothingConfigured: "Rien n'a encore été configuré pour ce logement.",
    newScene: 'Nouvelle ambiance',
    newSceneAria: 'Créer une nouvelle ambiance',
    scenesFolder: 'Ambiances',
    errorRenameImmutable: 'Cette ambiance a été configurée par CARO et ne peut pas être renommée.',
    errorSaveFailed: "L'enregistrement n'a pas réussi.",
    errorSceneLimit: "Il y a déjà douze ambiances. Supprimez-en d'abord une.",
    errorSceneEmpty: 'Choisissez au moins une lampe pour cette ambiance.',
    errorSceneNameRequired: 'Donnez un nom à cette ambiance.',
    errorSceneImmutable: 'Cette ambiance a été configurée par CARO.',
    errorDeleteFailed: "La suppression n'a pas réussi.",
    errorSceneOpenFailed: "Cette ambiance n'a pas pu être ouverte.",
    errorHomeFailed: "L'écran d'accueil n'a pas pu être mis à jour.",
    errorPrefFailed: "La modification n'a pas pu être enregistrée.",
    errorRoomFailed: "La pièce n'a pas pu être enregistrée.",
    notSent: 'Non envoyé',
    retry: 'Réessayer',
    sensorActive: 'actif',
    sensorIdle: 'au repos',
    sending: 'envoyé…',
    editAria: '{name}, modifier',
    readOnlyAria: '{name}, lecture seule, {extra}',
    longPressHint: '. Appuyez longuement pour varier.',
    hiddenBadge: 'masqué',
    editBadge: 'modifier',
    strengthOf: 'Intensité de {name}',
    close: 'Fermer',
    weaker: 'Plus faible',
    stronger: 'Plus fort',
    strength: 'Intensité',
    off: 'Éteint',
    full: 'Maximum',
    editScene: "Modifier l'ambiance",
    editSceneSub: 'Nom et lampes concernées',
    rename: 'Renommer',
    renameSub: 'Actuellement : {name}',
    moveToRoom: 'Déplacer vers une pièce',
    inRoom: 'Actuellement dans {room}',
    inNoRoom: "N'est dans aucune pièce. C'est ainsi que vous créez une nouvelle pièce.",
    homeRemove: "Retirer de l'écran d'accueil",
    homeAdd: "Mettre sur l'écran d'accueil",
    homeRemoveSub: "Actuellement sur l'écran d'accueil, à côté du bouton d'urgence",
    homeAddSub: "Apparaît sur l'écran d'accueil à côté du bouton d'urgence, pour ne pas devoir passer par ici",
    show: 'Afficher à nouveau',
    hide: 'Masquer',
    showSub: 'Revient dans la liste normale',
    hideSub: 'Reste visible dans ce mode de modification, pour pouvoir le rétablir',
    templateNote: "Cette ambiance a été configurée pour tout le bâtiment. Vous pouvez l'utiliser, mais pas la modifier.",
    whereTitle: 'Où se trouve {name} ?',
    cancel: 'Annuler',
    currentRoom: 'Se trouve ici actuellement',
    removeFromRoom: 'Retirer de {room}',
    removeFromRoomSub: "N'apparaîtra plus que sous « Tout »",
    newRoom: 'Nouvelle pièce',
    newRoomPlaceholder: 'Par exemple : Chambre',
    create: 'Créer',
    renameQuestion: 'Comment voulez-vous appeler ceci ?',
    save: 'Enregistrer',
    saving: 'Enregistrement…',
    newSceneTitle: 'Nouvelle ambiance',
    confirmDelete: 'Vous êtes sûr ?',
    delete: 'Supprimer',
    sceneName: "Nom de l'ambiance",
    sceneNamePlaceholder: 'Par exemple : Soirée',
    sceneRoomQuestion: 'Dans quelle pièce se trouve cette ambiance ?',
    sceneRoomPlaceholder: 'Laisser vide pour aucune pièce',
    sceneWhichLamps: 'Quelles lampes participent ?',
    sceneCaptureNow: 'Reprendre ce qui est allumé maintenant',
    sceneNoLamps: "Il n'y a pas encore de lampes à mettre dans une ambiance.",
    sceneStrengthOf: 'Intensité de {name} dans cette ambiance',
    on: 'allumé',
    offLower: 'éteint',
  },
  notifications: {
    title: 'Messages',
    backToHome: "Retour à l'écran d'accueil",
    empty: "Il n'y a aucun message pour le moment.",
    priorityUrgent: 'Urgent',
    priorityHigh: 'Important',
    priorityNormal: 'Message',
    priorityLow: 'Pour information',
    read: '• lu',
    unread: '• nouveau',
    today: "Aujourd'hui {time}",
    close: 'Fermer',
    stayUntilClosed: "Ce message reste affiché jusqu'à ce que vous le fermiez.",
    closesIn: 'Se ferme dans {n} secondes',
    pausedDuringCall: "En pause pendant l'appel",
    busy: 'En cours…',
    errorRouteNotAllowed: "Cette destination n'est pas autorisée.",
    errorNotDelivered: "La commande n'est pas arrivée. Veuillez réessayer.",
    errorUnavailable: 'Ce bouton est temporairement indisponible.',
    errorOffline: 'Pas de connexion. Veuillez réessayer.',
    errorExpired: "Ce message n'est plus valable.",
    errorGeneric: "Cela n'a pas fonctionné. Veuillez réessayer.",
    backgroundOf: 'Arrière-plan {n} sur {total}',
    cameraUnavailable: 'Image de la caméra indisponible',
    imageUnavailable: 'Image indisponible',
    previousImage: 'Image précédente',
    nextImage: 'Image suivante',
    goToImage: "Aller à l'image {n}",
    system: {
      system_test: { title: 'Message de test', body: 'Ceci est un test pour {name}.' },
    },
  },
  doorbellCamera: {
    door: 'Parlophone',
    camera: 'Caméra {name}',
    countdown: "L'image s'arrête dans {time}",
  },
  commandPopup: {
    message: 'Message',
    speaking: 'Lecture à voix haute',
    playingSound: 'Son',
    sound: 'Son : {sound}',
    times: ' ({n}x)',
  },
  gamesA11y: {
    goBack: 'Retour',
    backToGames: 'Retour aux jeux',
    moveUp: 'Vers le haut',
    moveLeft: 'Vers la gauche',
    moveDown: 'Vers le bas',
    moveRight: 'Vers la droite',
    flipCard: 'Retourner la carte',
    faceDownCard: 'Carte face cachée',
    emptySlot: 'Emplacement vide',
    cardOf: '{rank} de {suit}',
    cell: 'Case {n}',
    empty: 'vide',
    rowCol: 'Ligne {row}, colonne {col}',
    valueOf: 'valeur {value}',
    given: 'donné',
    redPiece: 'pion rouge',
    blackPiece: 'pion noir',
    white: 'Blanc',
    black: 'Noir',
    hint: 'indice',
    tile: 'Tuile {n}',
    tapToSlide: 'touchez pour glisser',
    hangmanFigure: 'Pendu : {wrong} lettres fausses sur {max}',
  },
};
